var _rect, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_44_4655)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_44_4655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 4H4V28H28V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_44_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7999 10.0001C7.47442 10.0001 6.3999 11.0746 6.3999 12.4001V22.0001C6.3999 23.3256 7.47442 24.4001 8.7999 24.4001H23.1999C24.5254 24.4001 25.5999 23.3256 25.5999 22.0001V12.4001C25.5999 11.0746 24.5254 10.0001 23.1999 10.0001H21.2969C20.9787 10.0001 20.6734 9.87366 20.4484 9.64863L19.1029 8.30304C18.6527 7.85295 18.0423 7.6001 17.4058 7.6001H14.594C13.9575 7.6001 13.3471 7.85295 12.897 8.30304L11.5514 9.64863C11.3263 9.87366 11.0211 10.0001 10.7029 10.0001H8.7999ZM15.9999 20.8001C17.9881 20.8001 19.5999 19.1883 19.5999 17.2001C19.5999 15.2119 17.9881 13.6001 15.9999 13.6001C14.0117 13.6001 12.3999 15.2119 12.3999 17.2001C12.3999 19.1883 14.0117 20.8001 15.9999 20.8001Z",
    fill: "#F9F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_4655",
    x1: 7.87718e-8,
    y1: 16.2319,
    x2: 32,
    y2: 16.2319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB829"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914706"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.822c4d30e56f248fbcab9553670ce471.svg";
export { ForwardRef as ReactComponent };